import { DepartureRequest } from "@/modules/Quickform/models/QuickformApi";
import { defineStore } from "pinia";

type QuickFormState = {
  departures: DepartureRequest[];
}

export type BookingPassengersAmount = {
  adult: number;
  adultConcession: number;
  child: number;
  childConcession: number;
  infant: number;
  infantConcession: number;
};

export const useQuickFormStore = defineStore("quickFormStore", {
  state: () => {
    return { departures: [] } as QuickFormState;
  },
  getters: {
    getDepartures: (state) => {
      return state.departures;
    },
    getPassengersAmounts: (state) => (type: string, resourceType: string) => {
      const amount = state.departures[0].resources.find(
        (p) => p.resourceType === resourceType && p.type === type
      )?.amount;
      return amount ? +amount : 0;
    },
  },
  actions: {
    setDepartures(departures: DepartureRequest[]) {
      this.departures = departures;
      window.sessionStorage.setItem("nl_departures", JSON.stringify(departures));
    },
  },
  persist: {
    key: "quickform",
    storage: window.sessionStorage
  },
});
